module.exports = __webpack_public_path__ + "app-static/img/a1.bfe98d1b.png";